import { render, staticRenderFns } from "./DocLayout.vue?vue&type=template&id=0d55bf00&"
import script from "./DocLayout.vue?vue&type=script&lang=js&"
export * from "./DocLayout.vue?vue&type=script&lang=js&"
import style0 from "./DocLayout.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules_dev/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports